<template>
  <div class="healthcare-investor">
    <v-container fluid class="mb-10">
      <v-row>
        <v-col cols="12">
          <h1 class="block-title">
            <img alt="Profile icon" src="@/assets/img/icons/healthcare.svg" class="pr-2" /><span>Healthcare Sector
              Overview and Opportunities</span>
          </h1>
        </v-col>
      </v-row>
      <v-row class="mb-8">
        <v-col cols="12">
          <p class="text-center mx-auto" style="max-width: 700px;">
            African Healthcare presents increasing opportunities for investors
            across asset classes as healthcare markets are developing rapidly
            across the continent. Africa makes up 16% of the global population
            (expanding to 25% by 2050) yet accounts for only 1% of global
            healthcare expenditures today. Recently Africa has seen a marked
            jump in overall share of investment across these markets, largely
            driven by Africa's young and fast-growing population, growing
            consumer class, changing healthcare economics, leapfrog tech
            opportunity, and recognition that private sector innovations are
            needed to overcome healthcare system inefficiencies.
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="5" offset-md="1" class="pr-md-15">
          <h3>Preview from study</h3>
          <a href="https://prosper-africa-assets.s3.us-gov-east-1.amazonaws.com/wp-content/uploads/2022/10/04164423/CrossBoundary_cProsperAfrica-Report_Round04-AdditionalSlides_vF75.pdf" target="_blank">
            <img alt="Trends" src="@/assets/img/trends.png" class="trends-image mb-7 mt-3" />
          </a>

          <h3 class="mb-4">Learn more about African healthcare markets and opportunities by reviewing <b>Prosper Africa's Market Study</b></h3>

          <div class="link-block" @click="openDoc">
            <svg class="doc-icon mr-3" height="37" width="29" viewBox="0 0 29 37" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.75002 0.583374C2.79966 0.583374 1.88823 0.960903 1.21622 1.63291C0.544216 2.30491 0.166687 3.21635 0.166687 4.16671V32.8334C0.166687 33.7837 0.544216 34.6952 1.21622 35.3672C1.88823 36.0392 2.79966 36.4167 3.75002 36.4167H25.25C26.2004 36.4167 27.1118 36.0392 27.7838 35.3672C28.4558 34.6952 28.8334 33.7837 28.8334 32.8334V11.3334L18.0834 0.583374H3.75002ZM3.75002 4.16671H16.2917V13.125H25.25V32.8334H3.75002V4.16671ZM7.33335 18.5V22.0834H21.6667V18.5H7.33335ZM7.33335 25.6667V29.25H16.2917V25.6667H7.33335Z" fill="#0D3068"/>
            </svg>
            <p>Investment and Trade Landscape and Opportunities in African Healthcare <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.8333 0.75V2.58333H14.1242L5.11333 11.5942L6.40583 12.8867L15.4167 3.87583V7.16667H17.25V0.75M15.4167 15.4167H2.58333V2.58333H9V0.75H2.58333C1.56583 0.75 0.75 1.575 0.75 2.58333V15.4167C0.75 15.9029 0.943154 16.3692 1.28697 16.713C1.63079 17.0568 2.0971 17.25 2.58333 17.25H15.4167C15.9029 17.25 16.3692 17.0568 16.713 16.713C17.0568 16.3692 17.25 15.9029 17.25 15.4167V9H15.4167V15.4167Z" fill="#0D3068"/>
              </svg>
            </p>

          </div>

          <v-divider class="d-md-none mb-10 mt-15"></v-divider>
        </v-col>

        <v-divider class="d-none d-md-inline-flex" vertical="true"></v-divider>

        <v-col cols="12" md="5" class="section-block block-right pl-md-15">
          <h3>Explore <b>illustrative examples</b> of opportunities in African Healthcare</h3>
          <div class="deals-list">
            <deal-item
              v-for="deal in deals"
              :key="deal._id"
              :deal="deal"
              :extended="false"
              :shortened="true"
              :active="false"
              class="deal-item"
              @click.native="showRegister"
            />
          </div>
          <v-btn
            :to="{ path: '/', hash: '#submission-form' }"
            color="#f0b323">
            View Live Deals
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <investor-footer />
  </div>
</template>

<script>
import DealItem from '@/components/deals/item'
import InvestorFooter from '@/components/sectors/investor-footer'
import dealsData from '@/data/healthcare'

export default {
  name: 'healthcare-investor',
  components: {
    DealItem,
    InvestorFooter
  },
  computed: {
    deals () {
      return dealsData
    }
  },
  methods: {
    openDoc () {
      window.open('https://prosper-africa-assets.s3.us-gov-east-1.amazonaws.com/wp-content/uploads/2022/10/04164423/CrossBoundary_cProsperAfrica-Report_Round04-AdditionalSlides_vF75.pdf', '_blank')
    },
    showRegister () {
      this.$router.push({ path: '/', hash: '#submission-form' })
    }
  }
}
</script>

<style lang="scss" scoped>
.healthcare-investor {
  padding-top: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  h3 {
    color: #0d3068;
    font-size: 22px;
    font-weight: 500;
    b {
      font-weight: 700;
    }
  }
}

.block-title {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0d3068;
  font-size: 32px;
  @media (min-width: 1024px) {
    font-size: 42px;
  }
}

.deal-item {
  padding: 0px;
  cursor: pointer;
}
.trends-image {
  width: 100%;
  border: 1px solid #E5E5E5;
}
.deals-list {
  :last-child {
    box-shadow: none!important;
  }
}
.link-block {
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #0d3068;
  background: #FEFBF4;
  padding: 20px;
  font-weight: 500;
  font-size: 20px;
  p {
    margin-bottom: 0px;
  }
}
.doc-icon {
  width: 29px;
}
</style>
